import { useSearchParams } from "react-router-dom";
import ProgressStepper from "./ProgressStepper";
import StepOne from "../steps/StepOne";
import StepTwo from "../steps/StepTwo";
import StepThree from "../steps/StepThree";
import StepFour from "../steps/StepFour";
import StepFive from "../steps/StepFive";
import PageWrapper from "../../../components/PageWrapper";
import StepSix from "../steps/StepSix";

const RenderData = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeStep = parseInt(searchParams.get("step") || "1");
  const handleStepChange = (newStep) => {
    if (newStep > 6 || newStep <= 0) return;
    setSearchParams({ step: newStep.toString() });
  };

  const stepNumberToComponentMap: Record<number, React.ReactNode> = {
    1: <StepOne />,
    2: <StepTwo />,
    3: <StepThree />,
    4: <StepFour />,
    5: <StepFive />,
    6: <StepSix />,
  };

  return (
    <PageWrapper>
      <div className="card h-full w-full flex flex-col">
        <ProgressStepper
          activeStep={activeStep}
          handleStepChange={handleStepChange}
        />
        <div className="h-[70%] flex-1 overflow-y-auto px-3 xl:px-4 2xl:px-10">
          {stepNumberToComponentMap[activeStep]}
        </div>
      </div>
    </PageWrapper>
  );
};

export default RenderData;
